var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMacro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84.54 63.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8f00ad;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        opacity: .4;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-2, .cls-5 {\n        fill: #3565ac;\n      }\n\n      .cls-3, .cls-8 {\n        fill: #00a99d;\n      }\n\n      .cls-4 {\n        fill: #3f348b;\n      }\n\n      .cls-6 {\n        fill: #df0d23;\n      }\n\n      .cls-7 {\n        fill: #b9db10;\n      }\n\n      .cls-9 {\n        fill: #bce037;\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22037",
    "data-name": "Grupo 22037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21441",
    "data-name": "Grupo 21441"
  }, /*#__PURE__*/React.createElement("path", {
    id: "verde",
    className: "cls-9",
    d: "m22.4,2.4h42.66v9.29H22.4V2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Turquesa",
    className: "cls-3",
    d: "m75.36,62.61H19.34l-.03-9.19h50.36c.66.1,1.27-.35,1.37-1.01.02-.12.02-.24,0-.36V18.25s11.28-.02,11.28-.02v37.83c-.07,3.69-3.12,6.63-6.81,6.56-.05,0-.1,0-.15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Azul",
    className: "cls-2",
    d: "m3.17,48.12l-.54-24.85c-.01-.99.17-1.97.54-2.88.34-.82.84-1.56,1.48-2.18.63-.6,1.38-1.07,2.2-1.38.86-.32,1.76-.48,2.68-.48h38.28v9.16H14.71c-.33-.04-.66.08-.89.32-.14.23-.21.49-.19.76v21.52H3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_170709",
    "data-name": "Trazado 170709",
    className: "cls-1",
    d: "m22.25,48.84c-.82-.36-1.56-.89-2.16-1.56l-.08-.09c-.26-.3-.49-.61-.69-.95-.21-.35-.38-.71-.53-1.09l-.03-.08c-.15-.4-.26-.81-.34-1.24-.08-.42-.11-.85-.11-1.28l-.22-5.5c-.02-1.07.2-2.13.63-3.11.38-.83.93-1.56,1.63-2.14.65-.55,1.41-.97,2.22-1.24.39-.13.79-.23,1.2-.3.4-.06,7.58.05,7.58.05v8.58s-3.18.09-3.18.73c0,.39.02.78.07,1.16l.02.04s.02.04.03.06c.06.12.15.22.25.31.29.24.65.37,1.03.36h.05l23.3-.44c.28,0,.56-.02.84-.09l.06-.02c.15-.04.29-.12.4-.23.19-.24.28-.55.24-.86v-.34l.22-9.02h9.84s-.22-2.73-.22,9.02h0c.13.64.2,1.29.22,1.95v.36c.29,3.9-2.64,7.29-6.53,7.58-.44.03-.88.02-1.31-.02l-31.49-.03c-1.01.01-2.02-.19-2.95-.59Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22044",
    "data-name": "Grupo 22044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22039",
    "data-name": "Grupo 22039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9736-3",
    "data-name": "Rect\\xE1ngulo 9736-3",
    className: "cls-7",
    d: "m68.72,0h2.02c7.62,0,13.81,6.18,13.81,13.81,0,0,0,0,0,0h0c0,.59-.48,1.06-1.06,1.06h-14.76c-.59,0-1.06-.48-1.06-1.06V1.06C67.65.48,68.13,0,68.72,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22040",
    "data-name": "Grupo 22040"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_9736-4",
    "data-name": "Rect\\xE1ngulo 9736-4",
    className: "cls-5",
    x: 50.5,
    y: 14.86,
    width: 16.33,
    height: 12.3,
    rx: 2.06,
    ry: 2.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22041",
    "data-name": "Grupo 22041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9738-2",
    "data-name": "Rect\\xE1ngulo 9738-2",
    className: "cls-8",
    d: "m.93,50.1h13.86c.52,0,.93.42.93.93,0,0,0,0,0,0v11.21c0,.52-.42.93-.93.93h-2.65C5.44,63.17,0,57.74,0,51.03h0c0-.52.42-.93.93-.93h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22042",
    "data-name": "Grupo 22042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9733-2",
    "data-name": "Rect\\xE1ngulo 9733-2",
    className: "cls-4",
    d: "m19,12.8H7.79c-3.17,0-5.73-2.57-5.73-5.73,0,0,0,0,0,0h0C2.06,3.9,4.62,1.34,7.79,1.34h11.21c.29,0,.53.24.53.53v10.4c0,.29-.24.53-.53.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22043",
    "data-name": "Grupo 22043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_9735-2",
    "data-name": "Rect\\xE1ngulo 9735-2",
    className: "cls-6",
    d: "m34.61,29.22h7.83c3.07,0,5.56,2.49,5.56,5.56h0c0,3.07-2.49,5.56-5.56,5.56h-7.83c-.28,0-.52-.23-.52-.52,0,0,0,0,0,0v-10.09c0-.28.23-.52.52-.52Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacro);
export default __webpack_public_path__ + "static/media/Macro.e9f40261221760b5dd7f75f9ebc45bf7.svg";
export { ForwardRef as ReactComponent };